import loadable from "@loadable/component";

export default loadable(() => import(/* webpackChunkName: "footer" */ "./Footer"));

export const GenericBrandDesc = loadable(() =>
    import(/* webpackChunkName: "GenericBrandDesc" */ "./components/GenericBrandDesc")
);
